"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameSessionProvider = GameSessionProvider;
exports.useGameSession = useGameSession;
exports.useGamemodeSettings = useGamemodeSettings;
const react_1 = __importStar(require("react"));
const GameSessionHolder_1 = require("./GameSessionHolder");
const GameSessionContext = (0, react_1.createContext)(null);
function GameSessionProvider({ children, holder }) {
    const ref = (0, react_1.useRef)(null);
    if (ref.current === null) {
        ref.current = holder !== null && holder !== void 0 ? holder : new GameSessionHolder_1.GameSessionHolder();
    }
    return (react_1.default.createElement(GameSessionContext.Provider, { value: ref.current }, children));
}
function useHolder() {
    const holder = (0, react_1.useContext)(GameSessionContext);
    if (!holder) {
        throw new Error("Must be used within a GameSessionProvider");
    }
    return holder;
}
function useGameSession() {
    const holder = useHolder();
    (0, react_1.useSyncExternalStore)(holder.subscribe, holder.getSnapshot);
    return holder.get();
}
function useGamemodeSettings() {
    return useGameSession().settings;
}
